import { Injectable } from '@angular/core';
import { MapMarker } from '@lowcodeunit/lcu-map-common';
import { analyzeAndValidateNgModules } from '@angular/compiler';

@Injectable({
    providedIn: 'root'
})

export class TempStorageService {

    // FIELDS
    // PROPERTIES

    /**
     * The constant that will be used to store the map list in local storage
     */
    protected readonly mapList: string = 'ambl_onMapList';

    protected readonly locationList: string = 'ambl_onLocationList';

    protected readonly masterLocationList: string = 'ambl_onMasterList';


    protected readonly lastUsedId: string = 'ambl_onLastUsedId';

    // CONSTRUCTORS

    constructor() {
        if (localStorage.getItem(this.mapList) === null) {
            localStorage.setItem(this.mapList, '');
        }
        if (localStorage.getItem(this.locationList) === null) {
            localStorage.setItem(this.locationList, '');
        }
        if (localStorage.getItem(this.masterLocationList) === null) {
            localStorage.setItem(this.masterLocationList, '');
        }
        if (localStorage.getItem(this.lastUsedId) === null) {
            localStorage.setItem(this.lastUsedId, '');

        }
    }

    // LIFECYCLE
    // APIS

    public GetLastUsedId() {
        return localStorage.getItem(this.lastUsedId);
    }

    public SetLastUsedId(id: string) {
        localStorage.setItem(this.lastUsedId, id);
    }

    // public AddMapToList(value: IndividualMap): void {
    //     // turn stored map into JS array
    //     const mapList = localStorage.getItem(this.mapList) === '' ? [] : JSON.parse(localStorage.getItem(this.mapList));
    //     // add map to array
    //     mapList.push(value)
    //     // save new array to local storage
    //     localStorage.setItem(this.mapList, JSON.stringify(mapList));
    // }

    // public ReplaceMap(value: IndividualMap): void {
    //     // turn stored map into JS array
    //     const mapList = localStorage.getItem(this.mapList) === '' ? [] : JSON.parse(localStorage.getItem(this.mapList));
    //     // get index in array of map to replace
    //     const idx = mapList.findIndex(map => {
    //         return map.id === value.id;
    //     });
    //     console.log(idx);
    //     // replace map in array with new map
    //     mapList.splice(idx, 1, value);
    //     // save new array to local storage
    //     localStorage.setItem(this.mapList, JSON.stringify(mapList));
    // }

    // public GetMapList(): Array<IndividualMap> {
    //     // parse JSON and return the array of maps from local storage
    //     if (localStorage.getItem(this.mapList) === '') {
    //         return [];
    //     } else {
    //         return JSON.parse(localStorage.getItem(this.mapList));
    //     }
    // }

    // public GetMapById(id: string): IndividualMap {
    //     // turn stored map into JS array
    //     const mapList = localStorage.getItem(this.mapList) === '' ? [] : JSON.parse(localStorage.getItem(this.mapList));
    //     // return map with given id
    //     return mapList.find(map => {
    //         return map.id === id;
    //     });
    // }

    public DeleteMapList(): void {
        localStorage.setItem(this.mapList, '');
        localStorage.setItem(this.locationList, '');
        localStorage.setItem(this.masterLocationList, '');
    }


    public SaveLocationLegend(list: Array<MapMarker>): void {
       
        localStorage.setItem(this.locationList, JSON.stringify(list));
        this.SaveMasterLocationLegend(list);
    }

    public GetLocationLegend() {
        if (localStorage.getItem(this.locationList) === '') {
            return [];
        } else {
            let temp: Array<MapMarker> = JSON.parse(localStorage.getItem(this.locationList));
            return temp;
        }
    }

    public SaveMasterLocationLegend(list: Array<MapMarker>): void {
        let master = this.GetMasterLocationLegend();
        let temp = master;
        for(let i = 0; i < list.length; i++){
            let listId = list[i].ID;
            //if the location does not already exist in the legend master list
            if(master.filter(item=> item.ID === listId).length === 0){
                //console.log("adding ", list[i], " to the master list");
                temp.push(list[i]);
            }
            //if the orderIndex has changed for a location this will update it
            if(master.filter(item => item.ID === listId && item.OrderIndex !== list[i].OrderIndex).length !== 0){
                let tempMaster = master.filter(item=> item.ID === listId);
                //console.log("Location = ", list[i].title);
                //console.log("Order index in master = ", tempMaster[0].orderIndex);
                //console.log("New order index = ", list[i].orderIndex);
               temp[master.indexOf(tempMaster[0])].OrderIndex = list[i].OrderIndex;
            }
        }
       
        localStorage.setItem(this.masterLocationList, JSON.stringify(temp));
    }

    public GetMasterLocationLegend() {
        if (localStorage.getItem(this.masterLocationList) === '') {
            return [];
        } else {
            let temp: Array<MapMarker> = JSON.parse(localStorage.getItem(this.masterLocationList));
            return temp;
        }
    }

    public GetLocationById(id: string): MapMarker {
        // turn stored locations into JS array
        const masterLocationList = localStorage.getItem(this.masterLocationList) === '' ? [] : JSON.parse(localStorage.getItem(this.masterLocationList));
        //console.log("masterLocationList = ", masterLocationList);
        // return location with given id
        return masterLocationList.find((location:any)  => {
            return location.id === id;
        });
    }

    // HELPERS

}
